<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar title="重置密码" align="center">
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>
  
    <br />
  
    <div class="gxx1">
      <div align=left>
  
        <mu-text-field hintText="请输入手机号" type="text" icon="smartphone" v-model="UserPhone" fullWidth="" style="margin-left:-4% ; width:103% " />
        <nobr>
          <!--图片附加码-->
          <mu-text-field hintText="请输入附加码" type="text" icon="vpn_key" v-model="FJM" style="margin-left:-4% ; width:69% " />
          <img v-bind:src="TPFJM" style="width:30% ;   float:right;   margin-top: -0.1rem" v-on:click="this.getValidateCode" />
        </nobr>
  
        <nobr>
          <mu-text-field hintText="请输入手机验证码" type="text" icon="verified_user" v-model="YZM" style="margin-left:-4% ; width:69% ; z-index: 1" class="txtValidate" />
  
          <span v-on:click="getYZM" v-show="haveYZM == false">
            <input type="button" value="获取" style="font-size:0.32rem ; float:right ; background-color:#27ba69 ; height: 0.7rem  ; border:none  ;  width: 30% ;  color:white" />
          </span>
          <span   v-show="haveYZM == true">
            <input type="button" v-model="WaitTime" style="font-size:0.32rem ; float:right ;   background-color:#eeeeee ;   height: 0.7rem  ; border:none  ;  width: 30% ; color:#999 ;" />
          </span>
        </nobr>
      </div>
  
      <!--outline:0 ;-->
  
      <mu-raised-button label="重置密码" primary="" @click="getPass" v-bind:style="{ width:'100%',height:'50px' }" style="font-size:0.3rem ; margin-top:0.5rem" />
      <br />
      <br />
      <br /> 系统将自动通过短信将密码发送到您的手机上
    </div>
  
    <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />
  
  </div>
</template>




<style lang="less" scoped="">
@import "../../../assets/theme.less";

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;


  .gxx1 {
    width: 82%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor ;
  }

  .Black {
    color: @primaryBlack ;
  }

  .Grey {
    color: @textColor ;
  }
}
</style>





<script>

import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'


export default {
  data() {

    return {
      UserPhone: '',
      FJM: '',
      YZM: '',

      TPFJM: '',

      haveYZM: false,
      WaitTime: '',
      CloseTime: 29,
      

      toast: false,
      TellUser: '',
    }
  },
  // 数据获取
  computed: {
    ...mapGetters([
      'g_UserInfo',
    ])
  },
  //进入时运作
  activated() {
    this.UserPhone ='';
    this.FJM ='';
    this.YZM ='';
    this.getValidateCode()

  },
  methods: {
    // 图片验证码
    getValidateCode() {
      this.TPFJM = api.getValidateCode();
    },

    //  获取验证码
    getYZM() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号';
        this.showToast();
      }
      else if (this.FJM == '') {
        this.TellUser = '请输入附加码';
        this.showToast();
      }
      else {
        // 开始计时
        this.haveYZM = true;
        this.WaitTime = this.CloseTime + "秒"
        this.timer();


        var params = new this.URLSearchParam();
        params.append('phoneNo', this.UserPhone);
        params.append('captcha', this.FJM);

        this.$http.post(api.ForgetPasswordForSMS(), params.toParam()).then((res) => {

          if (res.Result == true) {

            this.TellUser = res.Data;
            this.showToast();

          }
          else {  // 失败
            this.TellUser = res.Message;
            this.showToast();
            this.getValidateCode();

            this.CloseTime = 5 ;

          }

        })
      }
    },

    timer() {
      if (this.CloseTime > 0) {
        this.CloseTime--;
        this.WaitTime = this.CloseTime + "秒"
        
        setTimeout(this.timer, 1000);
      }
      else if (this.CloseTime == 0) {
        this.haveYZM = false;
        this.CloseTime = 29;
      }
    },
    //  获取验证码  END




    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    // 后退一页
    goback() {
      javascript: history.go(-1);
    },
    //  获取密码
    getPass() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号';
        this.showToast();
      }
      else if (this.YZM == '') {
        this.TellUser = '请输入手机验证码';
        this.showToast();
      }
      else {
        var params = new this.URLSearchParam();
        params.append('phoneNo', this.UserPhone);
        params.append('validateCode', this.YZM);

        this.$http.post(api.ForgetPassword(), params.toParam()).then((res) => {

          if (res.Result) {
            // this.TellUser = res.Data;
            // this.showToast();

            // 让登陆直接进usercenter
            var UserInfo = this.g_UserInfo;
            UserInfo.goUserCenter = true;
            this.setG_UserInfo(UserInfo);


            setTimeout(() => {
              this.TellUser = '密码重置成功'; this.showToast();
              setTimeout(() => { javascript: history.go(-1) }, 1500);
            }, 1500);
          }
          else {
            this.TellUser = res.Message;
            this.showToast();

          }


        })
      }

    },
    ...mapMutations([
      'setG_UserInfo',
    ]),


    // watch 对于后退，没用啊
  }
}



</script>










// WEBPACK FOOTER //
// wxBindForgetPass.vue?c35f6bf0